import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { LuChevronDown, LuCheck, LuMapPin, LuTrash2 } from 'react-icons/lu';
import api from '../../services/api';
import ModalShell from '../ui/ModalShell';

// Desde dónde sale el recorrido en el Mapa (3-nov-2026). Antes era un desplegable del navegador, con estilo
// distinto al resto de la app y sin forma de poner otro punto. Ahora: lista con el estilo de la app y
// "Otra dirección" (queda guardada para la próxima, como en Armar día; hasta 6).
// sedes: [{ id: 'DEPOSITO'|'BASE'|'G0'…, nombre, lat, lng }] · valor: '' = cada uno de la suya
export default function SalidaMapa({ sedes, valor, onCambiar, onSedes }) {
    const [abierto, setAbierto] = useState(false);
    const [dir, setDir] = useState('');
    const [guardando, setGuardando] = useState(false);
    const elegida = sedes.find(x => x.id === valor);

    const recargar = (lista) => {
        const guardadas = (lista || []).filter(x => x?.lat != null).map((x, i) => ({ id: `G${i}`, nombre: x.nombre || x.direccion, direccion: x.direccion, lat: x.lat, lng: x.lng }));
        onSedes([...sedes.filter(x => !String(x.id).startsWith('G')), ...guardadas]);
        return guardadas;
    };
    const agregar = async () => {
        const d = dir.trim();
        if (!d) return;
        setGuardando(true);
        try {
            const r = await api.post('/mapa/salidas', { direccion: d });
            const guardadas = recargar(r.data?.salidas);
            const nueva = guardadas.find(x => String(x.direccion || '').toLowerCase() === d.toLowerCase()) || guardadas[guardadas.length - 1];
            if (nueva) onCambiar(nueva.id);
            setDir(''); setAbierto(false);
        } catch (e) {
            toast.error(e?.response?.data?.mensaje || 'No encontré esa dirección');
        } finally {
            setGuardando(false);
        }
    };
    const quitar = async (x) => {
        try {
            const r = await api.delete('/mapa/salidas', { data: { direccion: x.direccion || x.nombre } });
            recargar(r.data?.salidas);
            if (valor === x.id || String(valor).startsWith('G')) onCambiar('');
        } catch { toast.error('No se pudo quitar'); }
    };

    const fila = (id, texto, sub = null, extra = null) => (
        <div key={id || 'cada'} className="flex items-center">
            <button type="button" onClick={() => { onCambiar(id); setAbierto(false); }}
                className="flex-1 min-w-0 flex items-center gap-3 py-3 px-1 text-left">
                <span className="flex-1 min-w-0">
                    <span className={`block text-body font-bold truncate ${valor === id ? 'text-brand-red' : 'text-ink'}`}>{texto}</span>
                    {sub && <span className="block text-caption text-muted truncate">{sub}</span>}
                </span>
                {valor === id && <LuCheck size={18} className="shrink-0 text-brand-red" />}
            </button>
            {extra}
        </div>
    );

    return (
        <>
            <button type="button" onClick={() => setAbierto(true)}
                className="h-9 px-3 shrink-0 rounded-xl bg-chip text-label font-black text-ink inline-flex items-center gap-1.5 max-w-[60%]">
                <LuMapPin size={14} className="shrink-0" />
                <span className="truncate">{elegida ? `Sale de ${elegida.nombre}` : 'Sale cada uno de su sede'}</span>
                <LuChevronDown size={14} className="shrink-0" />
            </button>
            {abierto && (
                <ModalShell titulo="Desde dónde sale" subtitulo="Para ver el recorrido del día en el mapa" onCerrar={() => setAbierto(false)}>
                    <div className="space-y-3">
                        <div className="divide-y divide-black/[0.06] dark:divide-white/[0.06]">
                            {fila('', 'Cada uno de su sede', 'Lucas del depósito, los demás de la base')}
                            {sedes.map(x => fila(x.id, x.nombre, x.direccion && x.direccion !== x.nombre ? x.direccion : null,
                                String(x.id).startsWith('G') ? (
                                    <button type="button" onClick={() => quitar(x)} aria-label={`Quitar ${x.nombre}`}
                                        className="w-10 h-10 shrink-0 rounded-lg text-muted flex items-center justify-center active:bg-chip"><LuTrash2 size={16} /></button>
                                ) : null))}
                        </div>
                        <div className="pt-1">
                            <p className="text-caption font-bold text-muted mb-1">Otra dirección</p>
                            <div className="flex gap-2">
                                <input value={dir} onChange={e => setDir(e.target.value)} onKeyDown={e => e.key === 'Enter' && agregar()}
                                    placeholder="Ej: Nicaragua 5902, CABA"
                                    className="flex-1 min-w-0 h-11 px-3 rounded-xl bg-chip text-body font-bold text-ink outline-none placeholder:text-muted" />
                                <button type="button" onClick={agregar} disabled={guardando || !dir.trim()}
                                    className="h-11 px-4 rounded-xl bg-[#C9341F] text-white text-label font-black disabled:opacity-40">{guardando ? '…' : 'Usar'}</button>
                            </div>
                            <p className="mt-1 text-caption text-muted">Queda guardada para la próxima. El depósito y la base se cambian en Rentabilidad → Ajustes.</p>
                        </div>
                    </div>
                </ModalShell>
            )}
        </>
    );
}
